export class EnviarEmailContatoInputDto {
  public nome: string;
  public email: string;
  public telefone?: string;
  public tipoManifestacao?: string;
  public mensagem: string;

  constructor(
    nome: string,
    email: string,
    mensagem: string,
    telefone?: string,
    tipoManifestacao?: string
  ) {
    this.nome = nome;
    this.email = email;
    this.mensagem = mensagem;
    this.telefone = telefone;
    this.tipoManifestacao = tipoManifestacao;
  }
}
